import { useMemo } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Icon from "./Icon";
import Tooltip from "./ToolTip";

const Toolbar = ({ buttons = [], components = [], tooltip = "", buttonTooltip = true, heading = "", className = 'h5' }) => {
    const [translate] = useTranslation();

    const renderedTooltip = useMemo(() => {
        if (tooltip) {
            if (buttonTooltip) {
                return (
                    <Tooltip text={tooltip} />
                );
            }
            return <div style={{ fontSize: '0.7em' }}>{tooltip}</div>
        }

        return null;
    }, [tooltip, buttonTooltip]);

    const renderHeading = useMemo(() => {
        if (heading) {
            return (
                <div className={`flex-grow-1 text-secondary`}>
                    <div className={`${className}`}>
                        {heading}
                    </div>
                    {renderedTooltip}
                </div>
            );
        }

        return null;
    }, [heading, className, renderedTooltip]);

    const renderButtons = useMemo(() => {
        return (
            buttons.map(({ name, text, variant, hidden, className, type, ...params }, index) => {
                return (
                    <Button
                        className={`ms-1 ${className || 'p-0 border-0'} ${hidden ? "d-none" : ""}`}
                        type={type || "button"}
                        variant={variant || "outline-primary"}
                        {...params}
                        key={index}
                    >
                        {name && <Icon icon={name} className="d-block" />}
                        {text && <span>{translate(text)}</span>}
                    </Button>
                );
            })
        )
    }, [buttons, translate]);

    return (
        <div className={`d-flex flex-grow-1 align-items-center`}>
            {renderHeading}
            {buttons.length > 0 && <div className={`d-flex align-items-center justify-content-end mt-0`} role="toolbar">
                {renderButtons}
            </div>}
            {components}
        </div>
    );
};

export default Toolbar;
